import { ExamCenterMemberGuard, ExamCenterProvider } from '@exam-center/exam-center-details';
import { useParams } from '@exam-center/router';
import { Outlet } from 'react-router-dom';

export default function ExamCenterLayout() {
  const { examCenterCode } = useParams('/:examCenterCode');
  return (
    <ExamCenterProvider examCenterCode={examCenterCode}>
      <ExamCenterMemberGuard examCenterCode={examCenterCode}>
        <Outlet />
      </ExamCenterMemberGuard>
    </ExamCenterProvider>
  );
}
